export default __webpack_public_path__ + "static/media/ic-refresh.0ced3ce0.svg";